import React from 'react'
import bgimage from '../../../assets/teambg.png'

type MemberCardProps = {
  name: string
  designation: string
  image: string
  title?: string
  edcDesignation?: string
}

const MemberCard: React.FC<MemberCardProps> = ({
  name,
  designation,
  image,
  title,
  edcDesignation,
}) => {
  return (
    <div
      className="
      w-full
      xs:max-w-[290px]
      sm:max-w-[250px]
      md:max-w-[240px]
      rounded-[16px]
      overflow-hidden
      shadow-md
      bg-white
      mb-3
    "
    >
      <div className="relative h-[200px] w-full bg-[#FDECEE]">
        <img
          src={bgimage}
          alt="pattern"
          className="absolute top-0 left-0 w-full h-full object-cover opacity-40"
        />
        <img
          src={image}
          alt={name}
          className="relative z-5 h-full w-full object-cover object-top"
        />
      </div>

      <div className="px-4 py-3 bg-gradient-to-b from-[#FFF7F3] to-white">
        {title && (
          <p className="text-xs font-bold text-blue-600 text-center uppercase tracking-wide mb-1">
            {title}
          </p>
        )}
        {edcDesignation && (
          <p className="text-[15px] font-semibold text-blue-600 text-center mb-1">
            {edcDesignation.charAt(0).toUpperCase() + edcDesignation.slice(1)}
          </p>
        )}
        <h3 className="text-sm font-semibold text-gray-900 text-center">
          {name.charAt(0).toUpperCase() + name.slice(1)}
        </h3>
        <p className="text-sm text-gray-900 mt-1 leading-snug text-center">
          {designation.charAt(0).toUpperCase() + designation.slice(1)}
        </p>
      </div>
    </div>
  )
}

export default MemberCard
